import { fetchDSOKProducts } from "app/services/api/management";

export const handleImportIkelp = async ({
  customer,
  setImportOpen,
  setImportProgress,
  enqueueSnackbar,
  t,
}) => {
  setImportOpen(true);
  setImportProgress(0);
  let current = 0;
  const importUrl =
    customer?.dsokSettings?.integrations?.productsManagement?.api
      ?.fetchProductsUrl || "";
  if (!importUrl) {
    enqueueSnackbar(t("pages.dsokCustomers.notifications.importFailed"), {
      variant: "error",
    });
    return;
  }
  const interval = setInterval(() => {
    current = Math.min(90, current + Math.floor(Math.random() * 7) + 3);
    setImportProgress((prev) => {
      const next = Math.max(prev ?? 0, current);
      return next > 90 ? 90 : next;
    });
  }, 250);

  try {
    const response = await fetchDSOKProducts(importUrl);
    if (response?.code === 200 && response?.status === "OK") {
      enqueueSnackbar(t("pages.dsokCustomers.notifications.importSuccessful"), {
        variant: "success",
      });
    } else {
      enqueueSnackbar(t("pages.dsokCustomers.notifications.importFailed"), {
        variant: "error",
      });
    }
  } catch (e) {
    enqueueSnackbar(t("pages.dsokCustomers.notifications.importFailed"), {
      variant: "error",
    });
  }
  clearInterval(interval);
  setImportProgress(100);
  setTimeout(() => {
    setImportProgress(null);
    setImportOpen(false);
  }, 500);
};
